import React, { Component } from 'react';

export class PopUpOnExitEmailForm extends Component {
  constructor(props) {
    super(props);
    this.state = { email: '' };
    this.onSubmit = this.onSubmit.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
  }

  componentDidMount() {

    const emailInputPop = document.querySelector('#popup input.form-control');
    const emailButtonPop = document.querySelector('#popup .btn-subscribe');


      emailButtonPop.addEventListener('mouseenter', e => {
          emailInputPop.classList.add('green');
      });


      emailButtonPop.addEventListener('mouseleave', e => {
          emailInputPop.classList.remove('green');
      });

      emailInputPop.addEventListener('focus', e => {
          emailButtonPop.classList.add('green');
      });

      emailInputPop.addEventListener('blur', e => {
          emailButtonPop.classList.remove('green');
      });

    setTimeout(function() {
      function onMouseOut(event) {
        // If the mouse is near the top of the window, show the popup
        // Also, do NOT trigger when hovering or clicking on selects
        if (
          event.clientY < 50 &&
          event.relatedTarget == null &&
          event.target.nodeName.toLowerCase() !== 'select') {
          // Remove this event listener
          document.removeEventListener("mouseout", onMouseOut);

          // Show the popup
          const popupExit = document.getElementById("popup");
          if (popupExit) {
            popupExit.style.display = "flex";
            setTimeout(function(){
                popupExit.style.opacity = "1";
            }, 50);
          }
        }
      }

      document.addEventListener("mouseout", onMouseOut);

      function onClosePopupBtnClick(event) {
        event.preventDefault();
        const popup = document.getElementById("popup")
        popup.style.opacity = "0";
        setTimeout(function(){
          popup.style.display = "none";
          popup.remove();
        }, 200);
      }

      const closePopupBtn = document.getElementById("close-popup-btn")
      if (closePopupBtn) {
        closePopupBtn.addEventListener('click', onClosePopupBtnClick);
      }

      }, 7000)

  }

  handleEmailChange(e) {
     this.setState({email: e.target.value});
  }

  onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    const overlayObject = document.querySelector('#overlay');
    const loaderObject = document.querySelector('#loader-object');
    const masterContainer = document.querySelector('.master-container');

    if (overlayObject) {
      overlayObject.style.display = 'flex';
    }
    if (loaderObject) {
      loaderObject.classList.add('loader');
    }
    if (masterContainer) {
      masterContainer.classList.add('blurred');
    }

    this.setState({email: e.target.value});

    const emailAddress = this.state.email

    fetch('/.netlify/functions/email-signup', {
        headers : {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          email_address: emailAddress
        }),
        method: 'POST'
      }).then(response => {
        if (response.status === 200) {
          // Insert new into popup
          document.getElementById("main-popup-text").innerHTML = 'Success! Thanks for joining Crafted. You should receive a confirmation email within a few minutes.';
          document.getElementById('back-to-reading-btn').style.display = 'block';
          const popUpForm = document.getElementById('popup-form');

          if (popUpForm) {
            popUpForm.style.display = 'none'
            popUpForm.remove();
          }

          if (overlayObject) {
            overlayObject.style.display = 'none';
          }
          if (loaderObject) {
            loaderObject.classList.remove('loader');
          }
          if (masterContainer) {
            masterContainer.classList.remove('blurred');
          }

          function onBackToReadingClick(event) {
            event.preventDefault();
            const popup = document.getElementById("popup")
            popup.style.opacity = "0";
            setTimeout(function(){
              popup.style.display = "none";
              popup.remove();
            }, 200);
          }

          const backToReadingBtn = document.getElementById("back-to-reading-btn");
          if (backToReadingBtn) {
            backToReadingBtn.addEventListener('click', onBackToReadingClick);
          }

        } else {
          window.alert('Oops! Something is not working. Please email us directly at hello@joincrafted.com to sign up.');
        }
      })
  }

  render() {
    return (
      <div id="popup">
        <button id="close-popup-btn" className="btn btn-link" type="button">X</button>
        <p id="main-popup-text"></p>
        <form id="popup-form" name="sign-up" onSubmit={this.onSubmit} method="POST" action="#" netlify-honeypot="humans-only" className="subscribe-form px-2">
          <p className="d-none">
            <label>Bot trap, not for humans: <input name="humans-only" /></label>
          </p>
          <div className="input-group">
            <input type="email" value={this.state.email || ''} onChange={this.handleEmailChange} className="form-control sign-up-email-input-popup" placeholder="Leave your email, join Crafted!" aria-label="Your email address" aria-describedby="email" required />
            <div className="input-group-append">
              <button id="btn-subscribe" className="btn btn-subscribe" type="submit">Get stories</button>
            </div>
          </div>
        </form>
        <a style={{display: 'none'}} id="back-to-reading-btn" className="" type="submit">Back to reading</a>
      </div>
    );
  }
}

export default PopUpOnExitEmailForm;
